import React from 'react';
import { Button, Card, DatePicker, Drawer, Form, Input, Space, Typography } from 'antd';
import { CreditCardOutlined } from '@ant-design/icons';
import InputNumber from 'components/input-number';
import ImagePicker from 'components/pickers/image/MultiImagePicker';
import { formatCurrency } from 'utils/number';
import { formatOnlyDate } from 'utils/date';
import { getOrderPaymentMethodLabel } from '../paymentMethodLabel';

const { Text } = Typography;

const MobileOrderPayment = ({ viewModel }) => {
  const {
    open,
    order,
    paymentHistories,
    showPaymentForm,
    savingPayment,
    form,
    openPaymentForm,
    closePaymentForm,
    savePayment,
    onClose,
    showUpdateDebtModal,
  } = viewModel;
  const paymentMethodLabel = getOrderPaymentMethodLabel(order);

  return (
    <>
      <Drawer
        title="Thanh Toán"
        placement="bottom"
        open={open}
        onClose={onClose}
        height="auto"
        styles={{ body: { maxHeight: '75vh', overflowY: 'auto' } }}
        destroyOnHidden
      >
        <Space direction="vertical" style={{ width: '100%' }} size={12}>
          {/* Tổng quan */}
          <Card size="small">
            <Space direction="vertical" style={{ width: '100%' }} size={6}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Text type="secondary">Tổng tiền</Text>
                <Text>{formatCurrency(order?.total_amount)}</Text>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                <Text type="secondary">Phương thức</Text>
                <Text style={{ textAlign: 'right' }}>{paymentMethodLabel}</Text>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Text type="secondary">Đã thanh toán</Text>
                <Text>{formatCurrency(order?.paid_amount)}</Text>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Text type="secondary">Còn lại</Text>
                <Text strong style={{ fontSize: 15 }}>{formatCurrency(order?.remain_amount)}</Text>
              </div>
            </Space>
          </Card>

          {/* Lịch sử thanh toán */}
          {paymentHistories.length > 0 && (
            <Space direction="vertical" style={{ width: '100%' }} size={8}>
              <Text type="secondary" style={{ fontSize: 13 }}>Lịch sử thanh toán</Text>
              {paymentHistories.map((item) => (
                <Card
                  key={item.payment.id}
                  size="small"
                  style={{ cursor: 'pointer' }}
                  onClick={() => showUpdateDebtModal(item.payment.id)}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Space direction="vertical" size={2}>
                      <Text style={{ fontSize: 13 }}>{item.payment.description}</Text>
                      <Text type="secondary" style={{ fontSize: 12 }}>{formatOnlyDate(item.payment.date)}</Text>
                    </Space>
                    <Text strong>{formatCurrency(item.amount)}</Text>
                  </div>
                </Card>
              ))}
            </Space>
          )}

          <Button
            type="primary"
            block
            size="large"
            icon={<CreditCardOutlined />}
            onClick={openPaymentForm}
          >
            Nhận thanh toán
          </Button>
        </Space>
      </Drawer>

      {/* Form nhận thanh toán (bottom sheet riêng) */}
      <Drawer
        title="Nhận thanh toán"
        placement="bottom"
        open={showPaymentForm}
        onClose={closePaymentForm}
        height="auto"
        destroyOnHidden
      >
        <Form layout="vertical" form={form}>
          <Form.Item name="id" hidden />
          <Form.Item
            name="amount"
            label="Số tiền"
            rules={[{ required: true, message: 'Bạn phải nhập số tiền' }]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            name="description"
            label="Nội dung"
            rules={[{ required: true, message: 'Bạn phải nhập nội dung' }]}
          >
            <Input placeholder="Nội dung" />
          </Form.Item>
          <Form.Item
            name="date"
            label="Ngày thanh toán"
            rules={[{ required: true, message: 'Bạn phải nhập ngày' }]}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item name="images" label="Hình ảnh">
            <ImagePicker />
          </Form.Item>
        </Form>
        <div style={{ padding: '8px 0 4px' }}>
          <Button type="primary" block loading={savingPayment} onClick={savePayment}>
            Lưu
          </Button>
        </div>
      </Drawer>
    </>
  );
};

export default MobileOrderPayment;
